import VerificationOfResidency from "./VerificationOfResidencyContainer";

export default VerificationOfResidency;
